import { combineReducers } from "redux";
import LoaderReducer from "./loader/loaderReducer";
import AppReducer from "./app/appReducer";
import LoginReducer from "./login/loginReducer";

export default combineReducers({
  loaderReducer: LoaderReducer,
  appReducer: AppReducer,
  loginReducer: LoginReducer,
});
